// Handle form submission loading states
document.addEventListener('DOMContentLoaded', () => {
  // Find all forms that should show loading state on submit
  const forms = document.querySelectorAll('form[data-submit-loader="true"]');
  
  forms.forEach(form => {
    if (form.dataset.submissionHandlerAttached) return;
    form.dataset.submissionHandlerAttached = 'true';

    form.addEventListener('submit', (e) => {
      const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
      
      // Only proceed if button exists and isn't already disabled
      if (!submitButton || submitButton.disabled) {
        return;
      }

      // Use setTimeout to ensure form data is captured before disabling
      setTimeout(() => {
        submitButton.disabled = true;
        
        // Store original text and show loading indicator
        const originalText = submitButton.innerHTML || submitButton.value;
        submitButton.dataset.originalText = originalText;
        
        if (submitButton.tagName === 'BUTTON') {
          submitButton.innerHTML = '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Processing...';
        } else {
          submitButton.value = 'Processing...';
        }
        
        submitButton.classList.add('submitting');
      }, 10);
    });
  });
});
